import { Dispatch } from 'redux';

import loadingStatuses from '@constants/loadingStatuses';

import {
  setConciergeBillingAddressData,
  setConciergeBillingAddressLs,
  setConciergeBillingData,
  setConciergeBillingLs,
  setConciergeBillingSubscriptionPriceRangesData,
  setConciergeBillingSubscriptionPriceRangesLs,
  setConciergeOrderPriceRangesData,
  setConciergeOrderPriceRangesLs,
} from '@redux/actions/billing-concierge.actions';
import {
  getBillingAddressApi,
  getBillingPriceRangesApi,
  getConciergeBillingDetailsApi,
  updateBillingAddressApi,
} from '@api/billing-concierge.api';
import {
  BillingConciergeAddressType,
  BillingConciergePriceRangeType,
  BillingConciergeType,
} from '@ts/billing-concierge.types';
import { getOrderPricingApi } from '@api/order.api';
import { OrderPricingType } from '@ts/orders.types';
import { addNotification } from '@redux/actions/notifications.actions';

export const fetchConciergeBillingDetails =
  (silent = false) =>
  (dispatch: Dispatch): Promise<BillingConciergeType> => {
    !silent && dispatch(setConciergeBillingLs(loadingStatuses.INITED));

    return getConciergeBillingDetailsApi()
      .then((billing) => {
        dispatch(setConciergeBillingData(billing));
        return billing;
      })
      .finally(() => {
        dispatch(setConciergeBillingLs(loadingStatuses.LOADED));
      });
  };

export const fetchConciergeSubscriptionPriceRanges =
  (silent = false) =>
  (dispatch: Dispatch): Promise<BillingConciergePriceRangeType> => {
    !silent && dispatch(setConciergeBillingSubscriptionPriceRangesLs(loadingStatuses.INITED));

    return getBillingPriceRangesApi()
      .then((billing) => {
        dispatch(setConciergeBillingSubscriptionPriceRangesData(billing));
        return billing;
      })
      .finally(() => {
        dispatch(setConciergeBillingSubscriptionPriceRangesLs(loadingStatuses.LOADED));
      });
  };

export const fetchConciergeOrderPriceRanges =
  (silent = false) =>
  (dispatch: Dispatch): Promise<OrderPricingType[]> => {
    !silent && dispatch(setConciergeOrderPriceRangesLs(loadingStatuses.INITED));

    return getOrderPricingApi()
      .then((orders) => {
        dispatch(setConciergeOrderPriceRangesData(orders));
        return orders;
      })
      .finally(() => {
        dispatch(setConciergeOrderPriceRangesLs(loadingStatuses.LOADED));
      });
  };

export const fetchBillingAddress =
  () =>
  (dispatch: Dispatch): void => {
    dispatch(setConciergeBillingAddressLs(loadingStatuses.INITED));

    getBillingAddressApi()
      .then((address) => {
        dispatch(setConciergeBillingAddressData(address));
      })
      .finally(() => {
        dispatch(setConciergeBillingAddressLs(loadingStatuses.LOADED));
      });
  };

export const updateBillingAddress =
  (addressFields: BillingConciergeAddressType) =>
  (dispatch: Dispatch): void => {
    updateBillingAddressApi(addressFields).then((updateAddress) => {
      dispatch(setConciergeBillingAddressData(updateAddress));
      dispatch(addNotification({ title: 'Billing address updated', type: 'success' }));
    });
  };
